module.exports = __webpack_public_path__ + "img/coround@2x.ea331fb.png";